import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { EmailChangeAutRequest, EmailChangeVerify } from '../../entities/email-change.entity';

@Injectable({
  providedIn: 'root',
})
export class EmailChangeInfraestructure {
  readonly #http = inject(HttpClient);
  readonly #emailChangeEndpoint = `${environment.apihost}/api/emailchange`;

  public startProcess(newEmail: string) {
    return this.#http.post<{ emailChangeRequestId: string }>(`${this.#emailChangeEndpoint}/startprocess`, undefined, {
      params: { email: newEmail },
    });
  }

  public requestTan(requestId: string) {
    return this.#http.post<void>(`${this.#emailChangeEndpoint}/requesttan`, requestId);
  }
  public requestAuth(data: EmailChangeAutRequest) {
    return this.#http.post<void>(`${this.#emailChangeEndpoint}/requestauth`, data);
  }
  public verify(data: EmailChangeVerify) {
    return this.#http.post<void>(`${this.#emailChangeEndpoint}/verify`, data);
  }

  public sendCodeOldEmail(requestId: string) {
    return this.#http.post<void>(
      `${this.#emailChangeEndpoint}/sendcodeoldemail`,
      {},
      {
        params: {
          requestId,
        },
      },
    );
  }
  public verifyOldEmail(code: string, requestId: string) {
    return this.#http.post<{ valid: boolean }>(
      `${this.#emailChangeEndpoint}/verifyoldemail`,
      {},
      {
        params: {
          code,
          requestId,
        },
      },
    );
  }

  public sendCodeNewEmail(requestId: string) {
    return this.#http.post<void>(
      `${this.#emailChangeEndpoint}/sendcodenewemail`,
      {},
      {
        params: {
          requestId,
        },
      },
    );
  }
  public verifyNewEmail(code: string, requestId: string) {
    return this.#http.post<{ valid: boolean }>(
      `${this.#emailChangeEndpoint}/verifynewemail`,
      {},
      {
        params: {
          code,
          requestId,
        },
      },
    );
  }

  public abortProcess(requestId: string) {
    return this.#http.post<void>(`${this.#emailChangeEndpoint}/abortprocess`, {}, { params: { requestId } });
  }
}
